import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
// import Index from '@/views/index'
// import Classroom from '@/views/classroom'
// import Course from '@/views/course'
import viewVideo from '@/views/viewVideo'
import videoList from '@/views/videoList'
Vue.use(Router)

const vueRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'viewVideo',
      component: viewVideo
    },
    // {
    //   path: '/classroom',
    //   name: 'Classroom',
    //   component: Classroom
    // },
    // {
    //   path: '/course',
    //   name: 'Course',
    //   component: Course
    // },
    {
      path: '/viewVideo',
      name: 'viewVideo',
      component: viewVideo
    },
    {
      path: '/videoList',
      name: 'videoList',
      component: videoList
    }
  ]
})

vueRouter.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

vueRouter.afterEach(() => {
  NProgress.done()
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js